import script from "./CourseShow.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseShow.vue?vue&type=script&setup=true&lang=js"

import "./CourseShow.vue?vue&type=style&index=0&id=b24ae606&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b24ae606"]])

export default __exports__